import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getUserData } from 'utils';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';
import { formatFieldLabel } from 'utils/formatting';

const RoleModal = ({ isOpen, onClose, type = 'add', initialData = {}, fetchAgain }) => {
  const userData = getUserData();
  console.log("RoleModal ~ userData:", userData)
  const clinic_id = userData?.clinic_id ?? 1;
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    roleName: Yup.string().required('Location Name is required'),
  });

  const formik = useFormik({
    initialValues: {
      roleName: initialData?.roleName || '',

    },
    validationSchema,
    onSubmit: (values) => {
      handleAddRole(values, { resetForm: formik.resetForm });
    },
  });

  const handleAddRole = async (values, { resetForm }) => {

    try {
      setLoading(true);

      // Prepare the payload
      const payload = {
        role_name: values.roleName,
        status: 'active',  // Setting the status to 'active' as per your requirement
        clinic_id,
        permissions: ["view_dashboard", "manage_patients", "view_reports"],

      };

      // Send the API request based on the endpoint
      await createAPIEndPoint(
        `clinic_roles`
      ).create(payload);
      fetchAgain()
      toast.success('New role added successfully!');
      setLoading(false);
      resetForm();
      onClose();
    } catch (error) {
      setLoading(false);
      console.error('Error adding role:', error);
      const errorMessage =
        error.response?.data?.error ||
        'An error occurred while adding the role.';
      toast.error(errorMessage);
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        borderRadius="16px"
        pb="16px"
        maxWidth={{ base: '90%', md: '448px' }}
        maxH="90vh"
        overflowY="auto"
      >
        <ModalHeader color="brand.500">
          {type === 'edit' ? 'Edit Role' : 'Create New Clinic Role'}
        </ModalHeader>
        <ModalCloseButton />
        <form onSubmit={formik.handleSubmit}>
          <ModalBody maxHeight="70vh" overflowY="auto" pb={2}>
            {[
              'roleName',
            ].map((field, index) => (
              <FormControl
                key={index}
                isInvalid={formik.touched[field] && formik.errors[field]}
                mb={2}
              >
                <FormLabel mb={0} textTransform="capitalize">
                  {/* {field.replace(/([A-Z])/g, ' $1').trim()} */}
                  {formatFieldLabel(field)}
                </FormLabel>
                <Input
                  name={field}
                  // placeholder={`Enter ${field
                  //   .replace(/([A-Z])/g, ' $1').trim().toLowerCase()}`}
                  placeholder={`Enter ${formatFieldLabel(field).toLowerCase()}`}
                  variant="auth"
                  fontSize="sm"
                  fontWeight="500"
                  value={formik.values[field]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched[field] && formik.errors[field] && (
                  <Text color="red.500" fontSize="sm">
                    {formik.errors[field]}
                  </Text>
                )}
              </FormControl>
            ))}
          </ModalBody>
          <ModalFooter pt={0}>
            <Button type="submit" colorScheme="brand" w="100%" mt={4} isLoading={formik.isSubmitting}> 
              {type === 'edit' ? 'Update Role' : 'Create Role'}
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default RoleModal;
